import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ITwoWayDependentWidgetPropsType from "./ITwoWayDependentWidget";
import MultiSelect from "../MultiSelectWidget";
import Label from "../../components/Label";
import "../../../assets/sass/widgets/container.scss";
import constantFile from "../../constants/constantFile";
import DeleteIcon from "../../components/DeleteIcon";
import * as draftListActionCreators from "../../components/DraftRegistration/actionCreators";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { imagePathurl } from "../../utils/utils";

/**
 * @class TwoWayDependent
 * @category Widgets
 * @description this compoennt used for rendering the low slopw square and its product,
 * there is a conditional validation where when the lowslope text box is filled then products are mandaroty and vice versa
 */
class TwoWayDependentWidget extends React.Component<ITwoWayDependentWidgetPropsType> {
    componentDidMount() {
        const { children } = this.props;
        const state = children[0].props.formData;
        this.setState({ ...state });
    }

    componentDidUpdate(prevProps, prevState) {
        const { deletePopupContent: oldDeletePopupContent } = prevProps;
        const { deletePopupContent: newDeletePopupContent, children, id } = this.props;
        if (
            oldDeletePopupContent.showPopup !== newDeletePopupContent.showPopup &&
            oldDeletePopupContent.confirm !== newDeletePopupContent.confirm
        ) {
            this.deleteAddendum(newDeletePopupContent.dataInfo);
        }
        if (this.props.errorDetails && this.props.errorDetails[id]) {
            if (children && children[0] && children[0].props && children[0].props.formData) {
                const formData = children[0].props.formData;
                this.isDataExist = false;
                this.isValueExist(formData);
                if (this.isDataExist) this.props.dynamicFormActions.removeFieldIdFromStore(id);
            }
        }
    }
    isValueExist = (data) => {
        for (const property in data) {
            if (data.hasOwnProperty(property)) {
                if (typeof data[property] == "object" && !Array.isArray(data[property])) {
                    this.isValueExist(data[property]);
                } else if (Array.isArray(data[property])) {
                    if (data[property].length > 0) {
                        this.isDataExist = true;
                    }
                } else if (data[property]) {
                    this.isDataExist = true;
                }
            }
        }
    };
    isDataExist = false;
    onTrashIconClick = (deleteId) => {
        const object = {
            title: constantFile.deleteGeneralTitle,
            description: constantFile.deleteGeneralDescription,
            buttonText: constantFile.deleteGeneralButtonText,
            showPopup: true,
            confirm: false,
            dataInfo: deleteId,
        };
        this.props.draftListActions.updateDeletePopup({ payload: object });
        document.body.classList.add("hideOverflow");
    };

    deleteAddendum = (className) => {
        const object = {
            title: "",
            description: "",
            buttonText: "",
            showPopup: false,
            confirm: false,
        };
        this.props.draftListActions.updateDeletePopup({ payload: object });
        const deleteItem: HTMLElement = document.querySelector(".d-none#" + className);
        deleteItem && deleteItem.click();
    };

    onMultiSelectChange = (node, selection) => {
        const childrenProps = this.props.children[0].props;
        const obj = { ...childrenProps.formData };
        const childrenSchema = childrenProps.schema.properties;
        Object.keys(childrenSchema).forEach((item) => {
            const resetNodeList =
                childrenSchema[node].const.allowOption === "one" &&
                childrenSchema[node].const.resetNode &&
                childrenSchema[node].const.resetNode.length > 0 &&
                childrenSchema[node].const.resetNode.map((node) => {
                    return node.split(".").slice(-1)[0];
                });
            if (item === node) {
                obj[item] = selection;
            } else if (resetNodeList && resetNodeList.length > 0 && resetNodeList.indexOf(item) !== -1) {
                obj[item] = [];
            }
        });
        childrenProps.onChange(obj);
    };

    render() {
        const { schema, classNames, id } = this.props;
        const childrenProps = this.props.children[0].props;
        const isParentId = schema.const && schema.const.optional && schema.const.parent_id;
        const title = childrenProps.schema.const.label;
        const childItems = childrenProps.schema.properties;
        const getimagePath = imagePathurl();
        const returnUIWidget = (child, childSchema) => {
            const widgetName = childSchema.const["ui:widget"];
            // const widgetName = uiSchema[child]["ui:widget"];
            if (widgetName === "gaf_multi_select") {
                return (
                    <MultiSelect
                        id={child}
                        schema={childSchema}
                        onChange={(newArr) => this.onMultiSelectChange(child, newArr)}
                        value={childrenProps.formData[child]}
                    />
                );
            }
            return null;
        };

        return (
            <div className={classNames} data-parentid={isParentId ? schema.const.parent_id : ""}>
                {isParentId && (
                    <div>
                        <span
                            id={`${schema.const.label.replace(/ +/g, "")}_delete_icon`}
                            className="delete-addendum"
                            onClick={() => this.onTrashIconClick(isParentId)}
                        >
                            <DeleteIcon />
                        </span>
                    </div>
                )}
                <legend>{title}</legend>
                {Object.keys(childItems).map((child, index) => {
                    const schema = childItems[child];
                    return (
                        <div key={`container-child-${index}`}>
                            <Label schema={schema} />
                            {returnUIWidget(child, schema)}
                        </div>
                    );
                })}
                {this.props.errorDetails[id] && this.props.errorDetails[id].length > 0 && (
                    <div className="error-message">
                        {this.props.errorDetails[id] &&
                            this.props.errorDetails[id].map((msg, id) => (
                                <p key={id}>
                                    <img className="ccz-img" src={`${getimagePath}error-field-icon.png`} alt="error" />
                                    &nbsp;
                                    {msg}
                                </p>
                            ))}
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        deletePopupContent: state.draftListInfo.deletePopup,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
    };
}
export const mapDispatchToProps = (dispatch) => {
    return {
        draftListActions: bindActionCreators(draftListActionCreators, dispatch),
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoWayDependentWidget);
